//React
import React, { useMemo } from "react";

//UI
import { Select } from "../../Common/Input/index";

//processing
import { useGetPMS } from "../../../hooks/pms.hooks";

const PMSSelect = (props) => {
  const { onChange, value } = props;

  const { data: pmsData } = useGetPMS();

  const PMSOptions = useMemo(() => {
    let options;
    if (pmsData) {
      options = pmsData.map((pms) => {
        return {
          value: pms._id,
          label: pms.pms_name,
        };
      });
    }
    return options;
  }, [pmsData]);

  return (
    <Select
      value={value}
      onChange={onChange}
      showSearch
      options={PMSOptions}
      placeholder="PMS"
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};

export default PMSSelect;
